import React from 'react';

const RouteNotFound = () => (
  <div>Cette page n'existe pas</div>
);
export default RouteNotFound;



// WEBPACK FOOTER //
// ./book/src/commons/components/RouteNotFound.jsx